export const UserIconMin = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width={24} height={24} fill="#D5DEFF" rx={12} />
    <path
      stroke="#2D5BFF"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16.667 17.25v-1.167a2.333 2.333 0 0 0-2.334-2.333H9.667a2.333 2.333 0 0 0-2.334 2.333v1.167m7-8.167a2.333 2.333 0 1 1-4.666 0 2.333 2.333 0 0 1 4.666 0Z"
    />
  </svg>
);
